import React from 'react';
import { PaletteIcon } from 'lucide-react';
import { CreativeDirectoryPage, CreativeArtist } from '../../components/creative/CreativeDirectoryPage';
const artists: CreativeArtist[] = [{
  id: '1',
  name: 'Rachel Foster',
  title: 'Traditional Painter',
  specialties: ['Oil Painting', 'Watercolor', 'Book Illustrations'],
  rating: 4.9,
  reviewCount: 87,
  imageUrl: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?ixlib=rb-1.2.1&auto=format&fit=crop&w=256&q=80',
  available: true,
  priceRange: '$400-1200'
}, {
  id: '2',
  name: 'Marcus Chen',
  title: 'Mixed Media Artist',
  specialties: ['Acrylic', 'Mixed Media', 'Portrait Art'],
  rating: 4.7,
  reviewCount: 64,
  imageUrl: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?ixlib=rb-1.2.1&auto=format&fit=crop&w=256&q=80',
  available: true,
  priceRange: '$300-900'
}];
const Painters = () => <CreativeDirectoryPage title="Traditional Painters" subtitle="Connect with skilled painters who create stunning traditional artwork for your book projects" icon={<PaletteIcon className="h-8 w-8" data-id="element-8624" data-mp="3f21sh3iyhwvq" />} profileBasePath="/creative/painters" artists={artists} data-id="element-8623" data-mp="13xxlmfa6n78i" />;
export default Painters;